var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import { raScreenXsMax, raScreenSmMax, raScreenMd, raScreenMdMax, raScreenLgMax, raScreenXl } from "@riseart/antd-provider/dist/website/variables.less";
var BREAKPOINTS_LIST = [{
  name: "xs",
  maxWidth: parseInt(raScreenXsMax, 10)
}, {
  name: "s",
  maxWidth: parseInt(raScreenSmMax, 10)
}, {
  name: "m",
  maxWidth: parseInt(raScreenMdMax, 10)
}, {
  name: "l",
  maxWidth: parseInt(raScreenLgMax, 10)
}];
var DEVICE_WIDTH = {
  mobile: parseInt(raScreenXsMax, 10),
  tablet: parseInt(raScreenMd, 10),
  desktop: parseInt(raScreenXl, 10)
};
function detectBreakpointByWidth(width) {
  var result = "xl";
  BREAKPOINTS_LIST.some(function(breakpoint) {
    if (width <= breakpoint.maxWidth) {
      result = breakpoint.name;
      return true;
    }
    return false;
  });
  return result;
}
__name(detectBreakpointByWidth, "detectBreakpointByWidth");
export {
  BREAKPOINTS_LIST,
  DEVICE_WIDTH,
  detectBreakpointByWidth
};
